import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ConditionalWrapper = ({ children, condition, wrapper = children => _jsx(_Fragment, { children: children }), }) => (condition ? wrapper(children) : children);
